// Uniform random integer in [0, max) from the Web Crypto CSPRNG.
// Rejection sampling avoids modulo bias.
function randomInt(max: number): number {
  const limit = Math.floor(0xffffffff / max) * max;
  const buf = new Uint32Array(1);
  do {
    crypto.getRandomValues(buf);
  } while (buf[0] >= limit);
  return buf[0] % max;
}

// Fisher-Yates shuffle using the CSPRNG.
function shuffle(chars: string[]): string[] {
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomInt(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars;
}

function buildPassword(length: number, categories: string[]): string {
  const allChars = categories.join('');
  const chars: string[] = [];

  // Ensure at least one character from each category
  for (const category of categories) {
    chars.push(category[randomInt(category.length)]);
  }

  // Fill the rest with random characters
  while (chars.length < length) {
    chars.push(allChars[randomInt(allChars.length)]);
  }

  return shuffle(chars).join('');
}

// Generate a secure password with good entropy
export function generateSecurePassword(length: number = 12): string {
  return buildPassword(length, [
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    'abcdefghijklmnopqrstuvwxyz',
    '0123456789',
    '!@#$%^&*()_+-=[]{}|;:,.<>?',
  ]);
}

// Generate a more readable password (avoids confusing characters)
export function generateReadablePassword(length: number = 12): string {
  return buildPassword(length, [
    'ABCDEFGHJKLMNPQRSTUVWXYZ', // No I, O
    'abcdefghjkmnpqrstuvwxyz', // No i, l, o
    '23456789', // No 0, 1
    '!@#$%^&*+-=',
  ]);
}
